// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.no-records-msg[data-v-063d120d] {\n    margin: auto;\n    text-align: center;\n}\na[data-v-063d120d]:hover {\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
